import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Organizacion } from '../interfaces/utilidades/pJuridica.interface';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PJuridicaService {

  private apiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/persona-juridica'; // Cambia esta URL según tu API

  constructor(private http: HttpClient) { }

  // Obtener todas las organizaciones
  getOrganizaciones(): Observable<Organizacion[]> {
    return this.http.get<Organizacion[]>(this.apiUrl);
  }

  // Obtener una organización por ID
  getOrganizacionById(id: number): Observable<Organizacion> {
    return this.http.get<Organizacion>(`${this.apiUrl}/${id}`);
  }

  // Crear una nueva organización
  create(organizacion: Organizacion): Observable<Organizacion> {
    return this.http.post<Organizacion>(this.apiUrl, organizacion);
  }

  // Actualizar una organización
  update(organizacion: Organizacion): Observable<Organizacion> {
    return this.http.put<Organizacion>(
      `${this.apiUrl}/${organizacion.id_persona_juridica}`,
      organizacion
    );
  }


  // Eliminar una organización
  deleteOrganizacion(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
